const CART_KEY = "cart";

const normalizeItem = (item) => ({
  producto_id: item.producto_id,
  nombre: item.nombre ?? item.nombre_producto ?? "",
  precio_unitario: Number(item.precio_unitario),
  precio_original: Number(item.precio_original ?? item.precio_unitario),
  en_oferta: Boolean(item.en_oferta),
  descuento_porcentaje: Number(item.descuento_porcentaje || 0),

  core_charge: Number(item.core_charge || 0),

  imagen: item.imagen,
  cantidad: item.cantidad,
  stock: item.stock,
});

export const getCart = () => {
  const data = localStorage.getItem(CART_KEY);
  if (!data) return [];

  const cart = JSON.parse(data);

  return cart.map((item) =>
    normalizeItem({
      ...item,
      cantidad: Math.min(Math.max(1, item.cantidad), item.stock ?? item.cantidad),
    })
  );
};

export const saveCart = (cart) => {
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
  notifyCartUpdated();
};

// Notifica a otros componentes (ej. el header) que el carrito cambió en esta pestaña.
const notifyCartUpdated = () => {
  try {
    window.dispatchEvent(new Event("cart:updated"));
  } catch {
    /* noop (SSR / sin window) */
  }
};

// Suma total de unidades en el carrito.
export const getCartCount = () =>
  getCart().reduce((sum, item) => sum + Number(item.cantidad || 0), 0);

// Total monetario del carrito (precio + core charge) * cantidad.
export const getCartTotal = () =>
  getCart().reduce(
    (sum, item) =>
      sum +
      (Number(item.precio_unitario || 0) + Number(item.core_charge || 0)) *
        Number(item.cantidad || 0),
    0
  );

export const addToCart = (product, cantidad = 1) => {
  const cart = getCart();
  const index = cart.findIndex((p) => p.producto_id === product.producto_id);
  const stock = Number(product.cantidad_disponible || 0);
  const core_charge = Number(product.core_charge || 0);

  // Si el producto tiene oferta vigente, el precio cobrado es el efectivo y se
  // conserva el original para mostrar el "antes/ahora" en el carrito.
  const enOferta = Boolean(product.en_oferta);
  const precioBase = Number(product.precio_unitario || 0);
  const precioCobrado = enOferta
    ? Number(product.precio_efectivo ?? precioBase)
    : precioBase;
  const descuento = enOferta ? Number(product.descuento_porcentaje || 0) : 0;

  if (index >= 0) {
    cart[index].cantidad = Math.min(cart[index].cantidad + cantidad, stock);
    cart[index].core_charge = core_charge;
  } else {
    cart.push(
      normalizeItem({
        producto_id: product.producto_id,
        nombre: product.nombre_producto || product.nombre,
        precio_unitario: precioCobrado,
        precio_original: precioBase,
        en_oferta: enOferta,
        descuento_porcentaje: descuento,
        core_charge,
        imagen: product.url_image,
        cantidad: Math.min(cantidad, stock),
        stock,
      })
    );
  }

  saveCart(cart);
  return cart;
};

export const updateCartQty = (producto_id, cantidad) => {
  let cart = getCart();

  cart = cart.map((p) =>
    p.producto_id === producto_id
      ? normalizeItem({
          ...p,
          cantidad: Math.min(Math.max(1, cantidad), p.stock),
        })
      : p
  );

  saveCart(cart);
  return cart;
};

export const removeFromCart = (producto_id) => {
  let cart = getCart();
  cart = cart.filter((p) => p.producto_id !== producto_id);
  saveCart(cart);
  return cart;
};

export const clearCart = () => {
  localStorage.removeItem(CART_KEY);
  notifyCartUpdated();
};
